import { render, staticRenderFns } from "./ExpulsionOrderFormEdit.vue?vue&type=template&id=2ae9c4ff&"
import script from "./ExpulsionOrderFormEdit.vue?vue&type=script&lang=ts&"
export * from "./ExpulsionOrderFormEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports